<template>
  <div id="crew-labor-dashboard">
    <page-layout-template />
  </div>
</template>

<script>
import PageLayoutTemplate from "./PageLayoutTemplate.vue";

export default {
  name: "CrewLaborDashboard",
  components: {
    PageLayoutTemplate,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
#labor-dashboard {
}
</style>
